/**
 * Meta conventions for sketch documents. All sketch-specific state rides in
 * tldraw's own meta fields, so a sketch stays an ordinary TLStoreSnapshot.
 */
import type { TLStoreSnapshot } from "@tldraw/tlschema";

import { PROJECT_UNITS_PER_PAGE_UNIT } from "./units";

export type UnitSystem = "imperial" | "metric";

export interface SketchDocumentMeta {
  projectUnitsPerPageUnit: number;
  unitSystem: UnitSystem;
}

export const DEFAULT_SKETCH_DOCUMENT_META: SketchDocumentMeta = {
  projectUnitsPerPageUnit: PROJECT_UNITS_PER_PAGE_UNIT,
  unitSystem: "imperial",
};

/** A Bear label on a drafting shape: what this geometry means in the model. */
export interface BearLabel {
  element?: string;
  name?: string;
  locationLine?: string;
  product?: string;
}

export interface SketchShapeMeta {
  bear?: BearLabel;
  note?: string;
}

type MetaRecord = { meta?: Record<string, unknown> };

/** Doc meta, defaulted so pre-sketch `.tldr` files read as ordinary sketches. */
export function sketchDocumentMeta(
  snapshot: TLStoreSnapshot,
): SketchDocumentMeta {
  const document = snapshot.store["document:document" as never] as
    | MetaRecord
    | undefined;
  const meta = document?.meta?.sketch as
    | Partial<SketchDocumentMeta>
    | undefined;
  return { ...DEFAULT_SKETCH_DOCUMENT_META, ...meta };
}

export function sketchShapeMeta(shape: MetaRecord): SketchShapeMeta {
  return (shape.meta?.sketch as SketchShapeMeta | undefined) ?? {};
}
